import { magnificPopupIframe, magnificPopupInline, magnificPopupSingleImage, magnificPopupGalleryImage } from './popups'
import { bannerSlider, bannerVideoGallerySlider, radleySlider, houseSlider, radleianSocietyNews, homepageDefiningRadley } from './sliders';
import { scrollTitle, loadingScreen } from './animations';
import scrollAnimations from './scrollAnimations';
import { admissionsAjax } from './admissionsAjax';
import { stickyHeader, boardingToggles, twoColumnsOneSticky, parallaxWithSpeed, dottedLineAnimation, oneWordPerLine } from './misc';
import customCursor from './custom-cursor';
import newsArchive from './news-archive';
import tabs from './tabs';

/* Components */
import header from '../../templates/components/site-header/site-header'
import accordion from '../../templates/components/accordion/accordion';
import imageSlider from '../../templates/components/image-slider';
import pageSlider from '../../templates/components/page-link-slider';
import newsSlider from '../../templates/components/related-news-slider';
import eventSlider from '../../templates/components/related-events-slider';
import socialSliders from '../../templates/components/social-twitter';
//import textImage from '../../templates/components/text-and-image';
import blockquotes from '../../templates/components/blockquotes/blockquotes';
import stickyTabs from '../../templates/components/sticky-tabs/sticky-tabs';
import bannerHome from '../../templates/components/banner/banner--home';
import verticalCarousel from '../../templates/components/vertical-carousel/vertical-carousel';
import whereNext from '../../templates/components/where-next/where-next';
import eligibilityCalculator from '../../templates/components/eligibility-calculator/eligibility-calculator';


function consoleMessage() {
	console.log('%cCreated by %cTWK%cwww.thewebkitchen.co.uk', 'background: #13212E; color: #FFFFFF; padding: 5px 0px 5px 10px; margin: 25px 0px;', 'background: #13212E; color: #05E5C8; padding: 5px 10px 5px 0px; font-weight: bold;', 'background: #FFFFFF; padding: 5px 10px;');
}

function usingJS() {
	document.querySelector('html').classList.remove('no-js')
	document.querySelector('html').classList.add('js')
}



/* *********************** */
/* Start all the functions */
/* *********************** */

// Init
consoleMessage()
usingJS()
scrollAnimations()
stickyHeader()

// Popups
magnificPopupIframe()
magnificPopupInline()
magnificPopupSingleImage()
magnificPopupGalleryImage()

// Sliders
bannerSlider()
bannerVideoGallerySlider()
imageSlider()
pageSlider()
newsSlider()
eventSlider()
socialSliders()
radleySlider()
houseSlider()
radleianSocietyNews()
homepageDefiningRadley()

// Animations
scrollTitle()
customCursor()
newsArchive()
loadingScreen()
dottedLineAnimation()

// Misc
tabs()
twoColumnsOneSticky()
parallaxWithSpeed()
oneWordPerLine()

// Components
header()
accordion()
boardingToggles()
admissionsAjax()
blockquotes()
stickyTabs()
bannerHome()
//textImage()
verticalCarousel()
whereNext()
eligibilityCalculator()



jQuery(document).ready(function ($) {
	ajax: {
		const paginationContainerToRemove = document.querySelectorAll('.no-pagination-available')

		if (paginationContainerToRemove.length > 0) {
			paginationContainerToRemove.forEach(element => {
				element.closest('.check-no-pagination-available').classList.add('hidden')
			});
		}

		$(document).on("sf:ajaxfinish", ".searchandfilter", function () {
			const paginationContainerToRemove = document.querySelectorAll('.no-pagination-available')

			if (paginationContainerToRemove.length > 0) {
				paginationContainerToRemove.forEach(element => {
					element.closest('.check-no-pagination-available').classList.add('hidden')
				});
			}
		});

	}
	externallinks: {
		$('a[href^="mailto:"]').each(function () {
			$(this).addClass('email-link');
		});

		$('a:not(.email-link):not([class^="magnific-"])').each(function () {
			var a = new RegExp('/' + window.location.host + '/');

			if (!a.test(this.href)) {
				$(this).click(function (event) {
					event.preventDefault();
					window.open(this.href, '_blank');
				});
			}
		});
		pdfs: {
			// Open PDFs in new window
			$(function () {
				$('a[href$=".pdf"]').prop('target', '_blank');
			});
		}
	}
});


